import auth from "../middlewares/auth";
export const blogs = [
    {
        path: '/blogs',
        component: () => import(/* webpackChunkName: "Blogs" */ '../views/blogs/Index'),
        name: 'blogs',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/blogs/add',
        component: () => import(/* webpackChunkName: "Blogs" */ '../views/blogs/Form'),
        name: 'blogs_add',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/blogs/edit/:id',
        component: () => import(/* webpackChunkName: "Blogs" */ '../views/blogs/Form'),
        name: 'blogs_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    },
];
